import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useSelector, useDispatch, connect } from "react-redux";

import { Link } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
// reactstrap
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import megamenuImg from "../../assets/images/megamenu-img.png";
import logo from "../../assets/images/logo.svg";
import logoLight from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

//i18n
import { withTranslation } from "react-i18next";

import {
  useQueryClient,
  useQuery,
} from "react-query";

import {
  getMasterSystems
} from "../../helpers/fakebackend_helper";

import {
  // getTodo as onGetTodo,
  getProfile as onGetProfile
} from "../../store/actions";
import Navbar from "./Navbar";
import tenxWhiteLogo from "../../assets/images/temperstack.png";

const Header = props => {

  const dispatch = useDispatch();

  const { todos } = useSelector(state => ({
    todos: state.Dashboard.todos
  }));

  // useEffect(() => {
  //   dispatch(onGetTodo());
  // }, [onGetTodo]);

  const { profile } = useSelector(state => ({
    profile: state.Dashboard.profile
  }));

  useEffect(() => {
    dispatch(onGetProfile());
  }, [onGetProfile]);

  const [menu, setMenu] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);

  return (
    <React.Fragment>
        <div className="navbar-header navbar-expand">
            <Navbar/>
        </div>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
